"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyGroupStatsSignificanceToJSON = exports.SurveyGroupStatsSignificanceFromJSONTyped = exports.SurveyGroupStatsSignificanceFromJSON = exports.SurveyGroupStatsSignificance = void 0;
/**
 *
 * @export
 */
exports.SurveyGroupStatsSignificance = {
    Unspecified: 'UNSPECIFIED',
    NoDifference: 'NO_DIFFERENCE',
    Increase90: 'INCREASE_90',
    Decrease90: 'DECREASE_90',
    Increase80: 'INCREASE_80'
};
function SurveyGroupStatsSignificanceFromJSON(json) {
    return SurveyGroupStatsSignificanceFromJSONTyped(json, false);
}
exports.SurveyGroupStatsSignificanceFromJSON = SurveyGroupStatsSignificanceFromJSON;
function SurveyGroupStatsSignificanceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveyGroupStatsSignificanceFromJSONTyped = SurveyGroupStatsSignificanceFromJSONTyped;
function SurveyGroupStatsSignificanceToJSON(value) {
    return value;
}
exports.SurveyGroupStatsSignificanceToJSON = SurveyGroupStatsSignificanceToJSON;
